module.exports = __webpack_public_path__ + "PTMETTAcontact-5.d64bab67.png";